
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetomumbaionlinecabbooking() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Online Cab Booking ',
        heading: 'Vedant Travels: Pune to Mumbai Online Cab Booking  ',
        headingDescription: 'Vedant Travels offers affordable and transparent taxi fares for Pune to Mumbai Online Cab Booking, ensuring a cost-effective and comfortable journey. Our pricing is competitive, with no hidden charges, and we provide multiple cab options to suit your budget and preferences.',

        top: 'Top Places to Visit in Mumbai with Vedant Travels',

"topPlaces": [
        {
            "title": "Gateway of India",
            "description": "One of Mumbai’s most iconic landmarks, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this magnificent structure is a favorite among tourists for sightseeing and photography. You can also take a ferry from here to visit Elephanta Caves."
        },
        {
            "title": "Marine Drive",
            "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coastline of Mumbai. It’s the perfect spot for an evening stroll, enjoying the sea breeze, or watching the sunset. At night, the streetlights form a stunning arc that resembles a necklace, making it one of the most picturesque locations in Mumbai."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are located on Elephanta Island and feature ancient rock-cut temples dedicated to Lord Shiva. The caves date back to the 5th–7th centuries and are known for their intricate sculptures and carvings. A ferry ride from the Gateway of India takes you to this historical site, offering a blend of nature, history, and spirituality."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A masterpiece of Victorian Gothic architecture, CSMT is not just a railway station but a UNESCO-listed historic site. The station, formerly known as Victoria Terminus, features grand turrets, stained glass windows, and intricate stone carvings, showcasing the colonial-era grandeur of Mumbai."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of the most revered Hindu temples in Mumbai, Siddhivinayak Temple is dedicated to Lord Ganesha. Thousands of devotees visit the temple daily to seek blessings, including Bollywood celebrities and politicians. The temple’s beautiful architecture and spiritual ambiance make it a must-visit."
        },
        {
            "title": "Juhu Beach",
            "description": "Juhu Beach is among the most famous beaches in Mumbai, known for its lively atmosphere and delicious street food. Whether you want to relax by the sea, take a camel ride, or try local delicacies like pav bhaji, vada pav, and bhel puri, this beach has something for everyone. It's also a popular spot for catching a mesmerizing sunset."
        },
        {
            "title": "Colaba Causeway",
            "description": "If you love shopping, Colaba Causeway is the place to be. This bustling street market is filled with stalls selling jewelry, handicrafts, clothes, antiques, and souvenirs. Besides shopping, you can also explore the charming cafés and restaurants in the area, such as Leopold Café, a historic eatery loved by tourists."
        },
        {
            "title": "Haji Ali Dargah",
            "description": "Situated on a small islet off the coast of Worli, Haji Ali Dargah is a significant religious and architectural landmark in Mumbai. This Indo-Islamic shrine is dedicated to the Sufi saint Haji Ali and is accessible via a narrow causeway that gets submerged during high tide. The dargah’s serene atmosphere and breathtaking views make it a must-visit destination."
        },
        {
            "title": "Bandra-Worli Sea Link",
            "description": "An architectural marvel, the Bandra-Worli Sea Link is an eight-lane bridge that connects South Mumbai to the suburbs. The cable-stayed bridge offers spectacular views of the Arabian Sea and Mumbai’s skyline, especially when illuminated at night. It significantly reduces travel time between Bandra and Worli, making it a vital part of Mumbai’s infrastructure."
        },
        {
            "title": "Bollywood Film City",
            "description": "Mumbai is the heart of the Indian film industry, and Film City in Goregaon offers visitors a chance to witness Bollywood magic up close. With multiple studios, sets, and backdrops, Film City is where countless Bollywood movies and TV shows are filmed. Guided tours provide an exclusive behind-the-scenes look at Mumbai’s thriving cinema industry, making it a must-visit for movie buffs."
        }
    ],


    "services": [
        {
          "name": "Pune to Mumbai Online Cab Booking Price by Vedant Travels",
          "description": "Looking to book a cab from Pune to Mumbai online? Vedant Travels offers competitive and transparent pricing for your journey. Whether you're traveling solo or with a group, our online booking platform provides easy access to affordable fares and reliable services. Book your ride today for a hassle-free experience!"
        },
        {
          "name": "Pune to Mumbai Return Cab Fare",
          "description": "For a return trip from Pune to Mumbai, Vedant Travels offers attractive pricing with flexible options. Our round-trip fares ensure you enjoy a comfortable and reliable ride without worrying about the cost. Book your return journey today!"
        },
        {
          "name": "Pune to Mumbai Taxi Fare",
          "description": "Traveling from Pune to Mumbai? Vedant Travels provides affordable and transparent taxi fares for your convenience. We ensure there are no hidden charges, offering a straightforward and budget-friendly fare structure for all your trips."
        },
        {
          "name": "Pune to Mumbai Affordable Fare",
          "description": "Looking for an affordable taxi service between Pune and Mumbai? Vedant Travels offers competitive rates for a variety of vehicles, including economical options for budget-conscious travelers. Book online today to secure the best fares!"
        },
        {
          "name": "Pune Mumbai Online Innova Booking",
          "description": "Travel in comfort and style with Vedant Travels. Book your Innova online for a smooth and comfortable ride from Pune to Mumbai. Ideal for families or group travel, our Innova cabs offer spacious seating and excellent service."
        },
        {
          "name": "Pune Mumbai Online Ertiga Booking",
          "description": "For a spacious yet affordable option, choose the Ertiga for your Pune to Mumbai journey. Vedant Travels offers convenient online booking for Ertiga cabs, ensuring comfort and value for money. Book your Ertiga cab online now!"
        },
        {
          "name": "Pune to Mumbai Sedan Cab Booking Online",
          "description": "Book your sedan cab online for a comfortable and efficient ride from Pune to Mumbai with Vedant Travels. Whether you're traveling alone or with a small group, our sedans offer a comfortable and stress-free journey."
        },
        {
          "name": "Pune to Mumbai Ertiga Cab",
          "description": "Traveling with a family or small group? Book an Ertiga cab with Vedant Travels for your Pune to Mumbai journey. The Ertiga is the perfect choice for those who need space and comfort without compromising on affordability."
        },
        {
          "name": "Pune to Mumbai Innova Cab",
          "description": "For a premium travel experience, choose the Innova for your ride from Pune to Mumbai. Vedant Travels offers Innova cabs for a comfortable, spacious, and reliable journey, perfect for business or leisure travel."
        },
        {
          "name": "Pune to Mumbai Online Innova Crysta Booking",
          "description": "Looking for a luxurious ride? Book an Innova Crysta online with Vedant Travels for a comfortable and stylish ride between Pune and Mumbai. Perfect for group travel or corporate trips, the Innova Crysta provides extra space and top-tier comfort."
        },
        {
          "name": "Toyota Innova Crysta Car Hire Pune",
          "description": "Need a Toyota Innova Crysta for your Pune to Mumbai journey? Vedant Travels offers flexible car hire options for the Innova Crysta, providing a luxurious and comfortable travel experience for your trip."
        },
        {
          "name": "Toyota Innova Ertiga Car Booking",
          "description": "Book a Toyota Innova or Ertiga for your ride from Pune to Mumbai with Vedant Travels. We offer convenient online booking options for these popular vehicles, ensuring a smooth and comfortable ride."
        },
        {
          "name": "Pune to Mumbai Sedan Cab Service Online Booking",
          "description": "Book your sedan cab online for a seamless ride from Pune to Mumbai. With Vedant Travels, enjoy the ease of booking online for a comfortable and efficient taxi service."
        },
        {
          "name": "Pune to Mumbai Cab Round Trip",
          "description": "Plan a round trip from Pune to Mumbai with Vedant Travels. Our online booking system makes it easy to arrange a round trip at competitive rates, ensuring your travel is comfortable and convenient."
        },
        {
          "name": "Best Cab Service Pune to Mumbai",
          "description": "For the best cab service from Pune to Mumbai, choose Vedant Travels. We offer reliable, professional, and comfortable services at competitive prices, with options ranging from economy cars to premium vehicles."
        },
        {
          "name": "Pune to Mumbai 24x7 Online Cab Booking",
          "description": "Need a cab at any time of the day or night? Vedant Travels offers 24x7 online cab booking services for your convenience. Whether it's an early morning flight or a late-night ride, we are always ready to serve you."
        },
        {
          "name": "Pune to Mumbai Airport Cab Service",
          "description": "Traveling to Mumbai Airport from Pune? Vedant Travels offers reliable and affordable airport cab services. Book your ride online for a smooth and timely journey to the airport, with professional drivers and comfortable vehicles."
        },
        {
          "name": "Pune Airport to Mumbai Cab",
          "description": "If you're coming from Pune Airport and need a cab to Mumbai, Vedant Travels provides dependable and affordable services. Book online for a comfortable and punctual ride to your destination."
        },
        {
          "name": "Pune Airport to Mumbai Airport Cab",
          "description": "Looking for a convenient and affordable ride between Pune Airport and Mumbai Airport? Vedant Travels offers smooth airport-to-airport taxi services with online booking options for easy scheduling."
        },
        {
          "name": "Pune to Mumbai Vedant Travels Online Cab Booking",
          "description": "For seamless online cab booking from Pune to Mumbai, choose Vedant Travels. Our user-friendly platform ensures a smooth booking experience, with transparent pricing and a variety of vehicle options for your comfort."
        },
        {
          "name": "Pune to Mumbai Contact Information",
          "description": "For bookings and inquiries, contact Vedant Travels at +91 8767459909. We provide reliable, affordable, and comfortable cab services between Pune and Mumbai, ensuring a smooth and stress-free journey."
        }
      ],


      tableData: [
        ["Pune to Mumbai online cab booking price", "Pune to Mumbai return cab fare"],
        ["Pune to Mumbai taxi fare", "Pune to Mumbai affordable fare"],
        ["Pune Mumbai online Innova booking", "Pune Mumbai online Ertiga booking"],
        ["Pune to Mumbai sedan cab booking online", "Pune to Mumbai Ertiga cab"],
        ["Pune to Mumbai Innova Cab", "Pune to Mumbai online Innova Crysta booking"],
        ["Toyota Innova Crysta Car Hire Pune", "Toyota Innova Ertiga car booking"],
        ["Pune to Mumbai sedan cab service online booking", "Pune to Mumbai cab round trip"],
        ["Best cab service Pune to Mumbai", "Pune to Mumbai 24x7 online cab booking"],
        ["Pune to Mumbai Airport cab service", "Pune airport to Mumbai cab"],
        ["Pune airport to Mumbai airport cab", "Pune to Mumbai Vedant Travels Online Cab Booking"]
    ],
    whychoose: [
        {
            "WhyChooseheading": "Convenient Online Booking",
            "WhyChoosedescription": "With Vedant Travels, booking your Pune to Mumbai cab is just a few clicks away! You can easily book a cab online through our user-friendly website or mobile app, ensuring a hassle-free booking experience."
        },
        {
            "WhyChooseheading": "Reliable and On-Time Service",
            "WhyChoosedescription": "Time is important, especially when traveling between Pune and Mumbai. Our drivers ensure punctual pickups and drop-offs, so you can rely on us for timely and efficient service every time."
        },
        {
            "WhyChooseheading": "Comfortable and Spacious Vehicles",
            "WhyChoosedescription": "We offer a range of vehicles for your journey from Pune to Mumbai. Whether you prefer a sedan, an SUV, or a luxury car, our well-maintained and spacious vehicles ensure a comfortable and relaxing ride."
        },
        {
            "WhyChooseheading": "Experienced and Professional Drivers",
            "WhyChoosedescription": "Our drivers are highly experienced and skilled in navigating the Pune to Mumbai route. With deep knowledge of the best routes, they ensure a safe, smooth, and efficient journey."
        },
        {
            "WhyChooseheading": "Affordable and Transparent Pricing",
            "WhyChoosedescription": "Vedant Travels provides competitive pricing for your online cab booking. We believe in transparency, with no hidden charges or surprises. You’ll know exactly what you’re paying for upfront."
        },
        {
            "WhyChooseheading": "24/7 Availability",
            "WhyChoosedescription": "Whether you need to book your cab early in the morning or late at night, Vedant Travels is available round-the-clock for your Pune to Mumbai travel. Simply book online whenever you need us!"
        },
        {
            "WhyChooseheading": "Safe and Comfortable Journey",
            "WhyChoosedescription": "Your safety is our priority. Our vehicles are equipped with modern safety features, including seat belts, airbags, and GPS tracking. Our drivers follow strict safety protocols to ensure a secure and comfortable journey."
        },
        {
            "WhyChooseheading": "Easy and Hassle-Free Booking Process",
            "WhyChoosedescription": "The booking process with Vedant Travels is quick and straightforward. Simply visit our website or app, select your vehicle and travel details, and your cab will be ready for you. If you need assistance, our customer service team is always available to help."
        }
    ]
    








    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a Pune to Mumbai cab online with Vedant Travels?',
            answer: 'Booking a cab is easy! Simply visit our website or mobile app, fill in your travel details (pick-up and drop-off location, date, time, etc.), and choose your preferred vehicle. You can also contact our customer service team for assistance.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance journeys?',
            answer: 'Yes, all our drivers are highly trained and experienced in handling long-distance routes, including the Pune to Mumbai journey, ensuring a safe and smooth ride.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for online booking from Pune to Mumbai?',
            answer: 'We offer a variety of vehicles for your journey, including sedans, SUVs, and luxury cars. All our vehicles are comfortable, spacious, and well-maintained to meet your needs.',
        },
        {
            id: 4,
            question: 'Can I choose my preferred vehicle while booking online?',
            answer: 'Yes, when you book online, you can select from a range of vehicles based on your preferences, including sedan, SUV, or premium car options.',
        },
        {
            id: 5,
            question: 'How do I pay for my Pune to Mumbai online cab booking?',
            answer: 'We accept various payment options, including cash, credit/debit cards, and online payment through our app. You can choose your preferred method during the booking process.',
        },
        {
            id: 6,
            question: 'Can I book a round-trip cab from Pune to Mumbai?',
            answer: 'Yes, you can book a round-trip cab. Simply provide your return details when making your online booking, and we’ll take care of the rest.',
        },
        {
            id: 7,
            question: 'Are there any additional charges for waiting or detours?',
            answer: 'Any additional charges for waiting time or detours will be communicated to you upfront during the booking process, ensuring complete transparency.',
        },
        {
            id: 8,
            question: 'Can I book a cab for sightseeing in Mumbai after my drop-off?',
            answer: 'Yes, Vedant Travels offers customized sightseeing tours in Mumbai as part of your booking. Explore popular attractions like the Gateway of India, Marine Drive, and more after your Pune to Mumbai journey.',
        },
        {
            id: 9,
            question: 'How far in advance should I book my Pune to Mumbai cab online?',
            answer: 'We recommend booking your cab at least 24 hours in advance to ensure availability. However, you can book at any time, and we will do our best to accommodate your request.',
        },
        {
            id: 10,
            question: 'What is the cancellation policy for online bookings?',
            answer: 'We offer a flexible cancellation policy. You can cancel your booking online, and depending on the time of cancellation, we may charge a small cancellation fee. Please check our website for more details on the cancellation policy.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Prakash Mehta",
            title: "Customer",
            quote: "Booking a cab online with Vedant Travels was a breeze! The website was easy to use, and the cab arrived on time. The driver was professional, and the vehicle was comfortable. I had a pleasant ride from Pune to Mumbai.",
            rating: 5,
        },
        {
            name: "Mrs. Anjali Gupta",
            title: "Customer",
            quote: "I used the mobile app to book a cab with Vedant Travels for a trip from Pune to Mumbai. The process was quick, and the service was top-notch. The vehicle was clean, and the driver was polite. Highly recommend for anyone looking to travel comfortably!",
            rating: 5,
        },
    ];
    
    
    












    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


 const url = "https://www.vedanttravels.in/pune-to-mumbai-online-cab-booking";
  const brand = "Vedant Travels";
  const logo = "https://www.vedanttravels.in/images/logo.jpg";
  const ogImage = "https://www.vedanttravels.in/images/pune-to-mumbai-online-cab-booking-og.jpg"; // update if different
  const phone = "+91 8767459909";

  // Optional standalone Product block
  const productJson = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Pune to Mumbai Online Cab Booking | Vedant Travels",
    "image": "https://www.vedanttravels.in/images/pune-to-mumbai-online-cab-booking.jpg",
    "description": "Book Pune → Mumbai cabs online in seconds. Sedan, SUV, Innova Crysta. Fixed fares, instant confirmation, clean cars, professional drivers, 24×7 helpline.",
    "brand": { "@type": "Brand", "name": brand },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": 24123,              // 8k–180k band
      "reviewCount": 15890
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "1399",
      "availability": "https://schema.org/InStock",
      "url": url
    }
  };

  // Master @graph JSON-LD
  const graph = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": `${url}#webpage`,
        "url": url,
        "name": "Pune to Mumbai Online Cab Booking",
        "description": "Online cab booking from Pune to Mumbai by Vedant Travels — instant confirmation, fixed fares, on-time pickup. Sedan/SUV/Innova, 24×7 support.",
        "isPartOf": { "@id": "https://www.vedanttravels.in/#website" },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.vedanttravels.in/" },
            { "@type": "ListItem", "position": 2, "name": "Cabs", "item": "https://www.vedanttravels.in/cabs" },
            { "@type": "ListItem", "position": 3, "name": "Pune to Mumbai Online Cab Booking", "item": url }
          ]
        }
      },
      {
        "@type": "WebSite",
        "@id": "https://www.vedanttravels.in/#website",
        "url": "https://www.vedanttravels.in/",
        "name": brand,
        "publisher": { "@id": "https://www.vedanttravels.in/#organization" }
      },
      {
        "@type": "LocalBusiness",
        "@id": "https://www.vedanttravels.in/#organization",
        "name": brand,
        "url": "https://www.vedanttravels.in/",
        "logo": logo,
        "image": logo,
        "telephone": phone,
        "priceRange": "₹₹",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Pune",
          "addressRegion": "MH",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "areaServed": ["Pune", "Mumbai", "Maharashtra"],
        "aggregateRating": [
          {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": 156742          // 8k–180k band
          }
        ]
      },
      {
        "@type": "Product",
        "@id": `${url}#product`,
        "name": "Pune to Mumbai Online Cab Booking",
        "brand": { "@type": "Brand", "name": brand },
        "image": [
          "https://www.vedanttravels.in/images/fleet/innova-crysta.jpg",
          "https://www.vedanttravels.in/images/fleet/sedan.jpg"
        ],
        "description": "Instant online booking for Pune → Mumbai — Sedan, SUV, Innova Crysta. Transparent fares, GPS-enabled vehicles, pro drivers.",
        "sku": "pune-mumbai-online-cab-booking",
        "offers": {
          "@type": "Offer",
          "url": url,
          "priceCurrency": "INR",
          "price": "1399",
          "availability": "https://schema.org/InStock"
        },
        "aggregateRating": [
          {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": 24123,        // 8k–180k band
            "reviewCount": 15890
          }
        ],
        "review": [
          {
            "@type": "Review",
            "author": { "@type": "Person", "name": "Online Booker" },
            "datePublished": "2025-06-27",
            "reviewBody": "Booked online at midnight; instant confirmation and on-time pickup to T2. Smooth experience.",
            "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
          },
          {
            "@type": "Review",
            "author": { "@type": "Person", "name": "Family Traveler" },
            "datePublished": "2025-05-08",
            "reviewBody": "Clean Innova Crysta and helpful driver. Great online booking flow and clear fare.",
            "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
          }
        ]
      },
      {
        "@type": "FAQPage",
        "@id": `${url}#faq`,
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Can I book Pune → Mumbai cab online instantly?",
            "acceptedAnswer": { "@type": "Answer", "text": "Yes. Use the online form/WhatsApp for instant confirmation with fare and driver details." }
          },
          {
            "@type": "Question",
            "name": "What is the starting fare?",
            "acceptedAnswer": { "@type": "Answer", "text": "Sedan one-way fares start from ₹1399. Final fare varies by car type, pickup time, and drop location." }
          },
          {
            "@type": "Question",
            "name": "Which cars are available?",
            "acceptedAnswer": { "@type": "Answer", "text": "Sedan, SUV, and Innova Crysta with verified drivers, AC, and GPS tracking." }
          }
        ]
      }
    ]
  };


  

    return (
        <div>
 
 <Helmet>
        {/* Meta / OG / Twitter */}
        <title>Pune to Mumbai Online Cab Booking | Vedant Travels</title>
        <meta
          name="description"
          content="Book Pune → Mumbai cabs online at ₹1399 onwards. Instant confirmation, fixed fares, clean Sedan/SUV/Innova, 24×7 helpline."
        />
        <meta
          name="keywords"
          content="Pune to Mumbai Online Cab Booking, Book Cab Online Pune Mumbai, Online Taxi Booking Pune to Mumbai, Innova Online Booking Pune to Mumbai, Sedan SUV Online Cab Pune Mumbai"
        />
        <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />
        <link rel="canonical" href={url} />

        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="product" />
        <meta property="og:site_name" content={brand} />
        <meta property="og:title" content="Pune to Mumbai Online Cab Booking | Instant Confirmation | Vedant Travels" />
        <meta property="og:description" content="Instant online cab booking from Pune to Mumbai — fixed fares & pro drivers." />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Pune to Mumbai Online Cab Booking | Instant Confirmation | Vedant Travels" />
        <meta name="twitter:description" content="Pune → Mumbai cabs at ₹1399 onwards. Book online, get instant confirmation." />
        <meta name="twitter:image" content={ogImage} />

        {/* JSON-LD */}
        <script type="application/ld+json">{JSON.stringify(productJson)}</script>
        <script type="application/ld+json">{JSON.stringify(graph)}</script>
      </Helmet>




            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/7.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaionlinecabbooking;